// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-33H3A";
var _4 = "disabilities-3BADE";
var _5 = "disabilities__header-2Cq0K";
var _6 = "disabilities__list-1seu7";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "disabilities", _5 as "disabilities__header", _6 as "disabilities__list" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "disabilities": _4, "disabilities__header": _5, "disabilities__list": _6 }
